import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"call, phone"} maskId="square-filled-radius-0-stroke-1-IconCall"><path d="M3.00943 3L3.002 3.49246C3.00067 3.58068 3 3.66905 3 3.75758C3 6.90523 3.84389 9.8573 5.3181 12.3982C6.82808 15.0009 8.99914 17.1719 11.6018 18.6819C14.1427 20.1561 17.0948 21 20.2424 21H21V14.5989L15.8404 13.4523L14.1631 15.1314C11.9186 13.9291 10.071 12.0814 8.86862 9.83689L10.5477 8.15964L9.40109 3H3.00943Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCall;
